import { useTranslation } from "@/hooks/useTranslation/useTranslation"

interface Props {
  unresolvedCount: number
  onRestore: () => void
  onApply: () => void
  onReturn: () => void
}

export function CancelDiffDialog({
  unresolvedCount,
  onRestore,
  onApply,
  onReturn,
}: Props) {
  const { translate } = useTranslation()
  return (
    <div className="fixed inset-0 z-60 flex items-center justify-center bg-black/50 backdrop-blur-xs">
      <div className="w-full max-w-md rounded-lg border border-grey4 bg-grey2 p-6 shadow-2xl">
        <div className="mb-4 flex items-center gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-warning/20">
            <svg
              className="h-5 w-5 text-warning"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-white">
              {translate("QMS/DIFF/OPEN_CHANGES")}
            </h3>
            <p className="mt-0.5 text-xs text-grey5">
              {translate("QMS/DIFF/UNRESOLVED_ROWS", {
                count: unresolvedCount,
              })}
            </p>
          </div>
        </div>

        <div className="space-y-2">
          <button
            onClick={onRestore}
            className="flex w-full items-start gap-3 rounded-lg border-2 border-grey4 px-4 py-3 text-left transition-all hover:border-grey5 hover:bg-grey3"
          >
            <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-grey3 text-grey5">
              <svg
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                />
              </svg>
            </div>
            <div>
              <p className="text-sm font-medium text-white">
                {translate("QMS/DIFF/RESTORE_ORIGINAL")}
              </p>
              <p className="mt-0.5 text-xs text-grey5">
                {translate("QMS/DIFF/RESTORE_HELP")}
              </p>
            </div>
          </button>

          <button
            onClick={onApply}
            className="flex w-full items-start gap-3 rounded-lg border-2 border-yellow5 px-4 py-3 text-left transition-all hover:border-yellow1 hover:bg-yellow5/20"
          >
            <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-yellow5/30 text-yellow1">
              <svg
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div>
              <p className="text-sm font-medium text-white">
                {translate("QMS/DIFF/CONTINUE_LATER")}
              </p>
              <p className="mt-0.5 text-xs text-grey5">
                {translate("QMS/DIFF/CONTINUE_LATER_HELP")}
              </p>
            </div>
          </button>

          <button
            onClick={onReturn}
            className="flex w-full items-start gap-3 rounded-lg border-2 border-yellow5 px-4 py-3 text-left transition-all hover:border-yellow1 hover:bg-yellow5/20"
          >
            <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-yellow5/30 text-yellow1">
              <svg
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
                />
              </svg>
            </div>
            <div>
              <p className="text-sm font-medium text-white">
                {translate("QMS/DIFF/RETURN_TO_REVIEW")}
              </p>
              <p className="mt-0.5 text-xs text-grey5">
                {translate("QMS/DIFF/RETURN_HELP")}
              </p>
            </div>
          </button>
        </div>
      </div>
    </div>
  )
}
